module.exports = __webpack_public_path__ + "img/notification.5a149a9f.svg";